import React, { Dispatch, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  CommonAction,
  ReduxCommonActionType,
} from '../../../store/modules/common';
import { SystemMenuId } from '../../../model/system/menu';
import 'vditor/dist/index.css';
import { ICommonSupportPageProps } from '../../../model';
import { AdminMessageDrawer } from './dialog';
import { PaginationTable } from '../../../components/pagination-table';
import { getAdminMessage } from '../../../api';
import { IMessageResItem } from '../../../model/api-modules';
import { wrapRequestArea } from '../../../lib/http/lib';
import { getLocalTime } from '../../../lib';
import {
  CommonButton,
  CommonButtonGroup,
} from '../../../components/button/main';
import { SYSTEM_LIST } from '../config';
import { IRootState } from '../../../store/reducers';

export const AdminMessage = (props: ICommonSupportPageProps) => {
  const { site } = props;
  const [showDrawer, setShowDrawer] = useState<boolean>(false);

  const [list, setList] = useState<IMessageResItem[]>([]);
  const [selectRow, setSelectRow] = useState<IMessageResItem>();
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);
  const menuDispatch = useDispatch<Dispatch<CommonAction>>();

  menuDispatch({
    type: ReduxCommonActionType.SELECT_MENU_ID,
    result: SystemMenuId.MessagePush,
  });

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    const res = await wrapRequestArea(
      () => getAdminMessage(SYSTEM_LIST.map((item) => item.value).join()),
      site
    );
    setList([...res]);
  };

  return (
    <div>
      <PaginationTable
        defaultPageSize={15}
        list={list}
        configFields={[
          {
            key: 'id',
            name: '消息ID',
          },
          {
            key: 'SubType',
            name: '消息类型',
            tableExtension: {
              renderRow(key, value: number) {
                const matched = SYSTEM_LIST.find(
                  (item) => item.value === value
                );
                if (matched) {
                  return matched.label;
                }
                return '';
              },
            },
          },
          {
            key: 'Title',
            name: '标题',
          },
          {
            key: 'studioName',
            name: '推送范围',
            tableExtension: {
              renderRow(_key, _val, record) {
                return [record.studioName?.Name, record.Receiver].join('/');
              },
            },
          },
          {
            key: 'CreateTime',
            name: '推送时间',
            tableExtension: {
              renderRow(key, val) {
                return getLocalTime(val, userInfo?.UserSettings?.Timezone);
              },
            },
          },
          {
            key: 'operate',
            name: '操作',
            tableExtension: {
              renderRow(_key, _val, record) {
                return (
                  <CommonButtonGroup>
                    <CommonButton
                      type="link"
                      onClick={() => {
                        setSelectRow(record);
                        setShowDrawer(true);
                      }}
                    >
                      查看详情
                    </CommonButton>
                  </CommonButtonGroup>
                );
              },
            },
          },
        ]}
        configFilter={{
          filters: [
            {
              name: 'create',
              type: 'add-btn',
              label: '新建推送',
              onClick() {
                setShowDrawer(true);
              },
            },
          ],
        }}
      />
      {showDrawer && (
        <AdminMessageDrawer
          record={selectRow}
          viewOnly={!!selectRow}
          onClose={() => {
            setShowDrawer(false);
            setSelectRow(undefined);
          }}
          onSave={() => {
            init();
            setSelectRow(undefined);
            setShowDrawer(false);
          }}
          site={site}
        />
      )}
    </div>
  );
};
